import { render, staticRenderFns } from "./e-tabs.vue?vue&type=template&id=472f29a2&scoped=true"
import script from "./e-tabs.vue?vue&type=script&lang=js"
export * from "./e-tabs.vue?vue&type=script&lang=js"
import style0 from "./e-tabs.vue?vue&type=style&index=0&id=472f29a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f29a2",
  null
  
)

export default component.exports